const codeWallBG = "/assets/images/wall.jpg";

const CodeWall = () => {
  return (
    <>
      <div
        className="codeWall"
        style={{
          backgroundImage: `url(${codeWallBG})`,
          cursor: "pointer",
        }}
        onClick={() => {
          alert("This is valid JS code, you can copy and paste it into your browser console to run it. :)");
        }}
      >
        <div className="code on">
          ロ='',コ=!ロ+ロ,Y=!コ+ロ,ㅣ=ロ+&#123;&#125;,ᗐ=コ[ロ++],Ξ=コ[Δ=ロ],ᐳ=++Δ+ロ,ㅡ=ㅣ[Δ+ᐳ],ウ="v
          ",コ[ㅡ+=ㅣ[ロ]+(コ.Y+ㅣ)[ロ]+Y[ᐳ]+ᗐ+Ξ+コ[Δ]+ㅡ+ᗐ+ㅣ[ロ]+Ξ][ㅡ](Y[ロ]+Y[ロ+ロ]+コ[ᐳ]+Ξ+ᗐ+
          "((コ.Y+ㅣ)[ᐳ*Δ-ロ]+ウ[1]+Y[Δ]+ㅡ[ロ]+ウ[ロ-ロ]+コ[ᐳ]+ウ[1]+ㅣ[ᐳ]+Y[ᐳ])")()
        </div>
        {/*
        <input className="toggle" type="checkbox" checked
        onClick="document.getElementsByClassName('code')[0].classList.toggle('on')">
        */}
      </div>
    </>
  );
};

export default CodeWall;
